import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { DesignerState } from './DesignerFlow';
import { CheckIcon } from 'lucide-react';
interface Props {
  data: DesignerState;
  updateData: (data: Partial<DesignerState>) => void;
  onNext: () => void;
  onBack: () => void;
}
export function Step2Goals({
  data,
  updateData,
  onNext,
  onBack
}: Props) {
  const goalsList = ['Team alignment', 'Leadership development', 'Wellness and reset', 'Strategy', 'Culture building', 'Networking', 'Sales performance', 'Training', 'Recognition', 'Client experience', 'Communication', 'Trust building', 'Customer service excellence'];
  const toggleGoal = (goal: string) => {
    if (data.goals.includes(goal)) {
      updateData({
        goals: data.goals.filter(g => g !== goal)
      });
    } else if (data.goals.length < 3) {
      updateData({
        goals: [...data.goals, goal]
      });
    }
  };
  const isValid = data.goals.length > 0;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-2511">
      <div className="mb-8" data-id="element-2512">
        <h1 className="text-3xl font-bold text-brand-navy mb-2" data-id="element-2513">
          What should this offsite accomplish?
        </h1>
        <p className="text-slate-600" data-id="element-2514">
          Choose up to three priorities. ({data.goals.length}/3 selected)
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-2515">
        {goalsList.map(goal => {
        const isSelected = data.goals.includes(goal);
        const isDisabled = !isSelected && data.goals.length >= 3;
        return <button key={goal} onClick={() => toggleGoal(goal)} disabled={isDisabled} className={`text-left p-4 rounded-xl border transition-all duration-200 flex flex-col justify-between min-h-[100px] ${isSelected ? 'border-brand-teal bg-brand-teal/5 ring-1 ring-brand-teal' : isDisabled ? 'border-slate-100 bg-slate-50 opacity-50 cursor-not-allowed' : 'border-slate-200 hover:border-brand-teal/50 hover:bg-slate-50'}`} data-id="element-2516">
              <span className={`text-sm font-semibold ${isSelected ? 'text-brand-navy' : 'text-slate-700'}`} data-id="element-2517">
                {goal}
              </span>
              {isSelected && <div className="mt-2 w-5 h-5 rounded-full bg-brand-teal text-white flex items-center justify-center self-end" data-id="element-2518">
                  <CheckIcon className="w-3 h-3" data-id="element-2519" />
                </div>}
            </button>;
      })}
      </div>

      <div className="mb-8" data-id="element-2520">
        <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2521">
          What would make this event successful?
        </label>
        <textarea value={data.successCriteria} onChange={e => updateData({
        successCriteria: e.target.value
      })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all min-h-[100px] resize-y" placeholder="e.g. We need the sales and product teams to finally get on the same page..." data-id="element-2522" />
      </div>

      <div className="mt-10 pt-6 border-t border-slate-100 flex justify-between items-center" data-id="element-2523">
        <Button variant="ghost" onClick={onBack} data-id="element-2524">
          Back
        </Button>
        <Button variant="primary" size="lg" onClick={onNext} disabled={!isValid} data-id="element-2525">
          Continue
        </Button>
      </div>
    </motion.div>;
}